export default "__VITE_ASSET__610a62b5__"